import {
  NavSection,
  NavSectionType
} from "@/pages/settings/components/settingsNav/NavSection";

interface NavProps {
  currentPageName?: string;
  isCollapsed: boolean;
  onPageClick: (targetName: string) => void;
  sections: NavSectionType[];
}

export function Nav({
  currentPageName = "/",
  onPageClick,
  sections,
  isCollapsed
}: NavProps) {
  return (
    <div
      data-collapsed={isCollapsed}
      className="group flex flex-col gap-4 py-2 bg-surface-sidebar-navigation text-h2"
    >
      <nav className="grid gap-4 px-2 group-[[data-collapsed=true]]:justify-start group-[[data-collapsed=true]]:px-2">
        {sections.map((section) => (
          <NavSection
            key={section.title}
            title={section.title}
            items={section.items}
            onPageClick={onPageClick}
            currentPageName={currentPageName}
          />
        ))}
      </nav>
    </div>
  );
}
